import {TABS} from '../consts/logsTabs';

const TabBar = ({activeTab, onTabChange}) => (
    <div className='mb-3 flex gap-1 rounded-md bg-gray-100 p-0.5'>
        {Object.values(TABS).map((tab) => (
            <div
                key={tab}
                className={`text-xs flex-1 cursor-pointer rounded py-1.5 text-center font-medium transition-all ${
                    activeTab === tab ? 'bg-white text-color-primary shadow-sm' : 'text-gray-500 hover:text-gray-700'
                }`}
                onClick={() => onTabChange(tab)}
            >
                {tab}
            </div>
        ))}
    </div>
);

export default TabBar;
